<script>

    import {onDestroy, untrack} from "svelte";

    let {for: tooltipFor, show, onhide, isSelected} = $props();

    let timer;

    onDestroy(() => {
        clearTimeout(timer);
    });

    $effect(function () {

        // registering isSelected as dependency but not using it
        let _ = isSelected;
        let s = untrack(() => show);

        if (s) {
            clearTimeout(timer);
            timer = setTimeout(() => {
                onhide?.();
            }, 2000);
        }
    });
</script>

<wa-tooltip
        style="--background-color: var(--hrst-green-600)"
        open={show}
        trigger="manual" for={tooltipFor} placement="top-end">
    {#if isSelected}
        Service successfully added
    {:else}
        Service successfully removed
    {/if}
</wa-tooltip>